
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investment/why-invest",
      function () {
        return require("private-next-pages/investment/why-invest/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investment/why-invest"])
      });
    }
  